<template>

    <div class="sort">

        <bottom-sheet ref="BSS" @closeModal="close" v-show="!isDesktop">
            <sort-body @close="close"></sort-body>
        </bottom-sheet>

        <div class="sort__desktop" v-show="isDesktop && show">
            <sort-body @close="close"></sort-body>
        </div>

    </div>

</template>

<script>
import Tag from '@/modules/tag'

import BottomSheet from '@/components/bottomSheet/BottomSheet'
import SortBody from '@/components/newsletters-v2/sort/SortBody'

export default {

    name: 'sort',

    components: {
        BottomSheet,
        SortBody
    },

    data() {
        return {
            show: false
        }
    },

    methods: {
        open() {
            this.show = true
            this.$refs.BSS.open()
            Tag.pageViewGA(this, 'sort_email')
        },

        close() {
            this.show = false
            this.$refs.BSS.close()
        }
    }
}
</script>

<style lang="scss" scoped>

.sort {
    &__desktop {
        width: 340px;
        background-color: $white;
        position: fixed;
        top: 136px;
        right: 60px;
        border-radius: 16px;
        box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.05);
        z-index: 2;
    }
}
</style>
